// ======================================================================
// 📁 File: src/modules/ticket/routes/TicketRoutes.jsx
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import TicketLayout from "../TicketLayout";
import TicketDashboard from "../pages/TicketDashboard";
import TicketList from "../pages/TicketList";
import TicketCreate from "../pages/TicketCreate";
import TicketDetailPage from "../pages/TicketDetailPage";

import SlaDashboardPage from "../pages/sla/SlaDashboardPage";
import PerformanceDashboardPage from "../pages/performance/PerformanceDashboardPage";

export default function TicketRoutes() {
  return (
    <Routes>
      {/* Default Route */}
      <Route
        index
        element={
          <TicketLayout>
            <TicketDashboard />
          </TicketLayout>
        }
      />

      {/* Explicit dashboard path */}
      <Route
        path="dashboard"
        element={
          <TicketLayout>
            <TicketDashboard />
          </TicketLayout>
        }
      />

      {/* SLA Dashboard */}
      <Route
        path="sla-dashboard"
        element={
          <TicketLayout>
            <SlaDashboardPage />
          </TicketLayout>
        }
      />

      {/* ✅ Performance Dashboard */}
      <Route
        path="performance-dashboard"
        element={
          <TicketLayout>
            <PerformanceDashboardPage />
          </TicketLayout>
        }
      />

      {/* All Tickets */}
      <Route
        path="all"
        element={
          <TicketLayout>
            <TicketList filter="all" />
          </TicketLayout>
        }
      />

      {/* My Tickets */}
      <Route
        path="my"
        element={
          <TicketLayout>
            <TicketList filter="my" />
          </TicketLayout>
        }
      />

      {/* Create Ticket */}
      <Route
        path="create"
        element={
          <TicketLayout>
            <TicketCreate />
          </TicketLayout>
        }
      />

      {/* Ticket Detail */}
      <Route
        path="view/:ticketId"
        element={
          <TicketLayout>
            <TicketDetailPage />
          </TicketLayout>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}
